exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-35c578c7] {\n  text-decoration: underline;\n  color: inherit;\n}\n", ""]);

// exports
